import { useAdminUpdate } from '@reapitform/hooks'
import { AdminEventTemplate, AdminEventTemplatePayload } from '../types'

/** Updates an event template (`PUT /api/forms/{formRef}/versions/{versionRef}/event-templates/{eventTemplateRef}`). */
export const useUpdateAdminEventTemplate = (
  formReferenceID: string,
  versionReferenceID: string,
  eventTemplateReferenceID: string,
) =>
  useAdminUpdate<AdminEventTemplatePayload, AdminEventTemplate>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/event-templates/${eventTemplateReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the notification',
    successMessage: 'Notification updated',
  })
